import uniAdminApi from "./api";

const departmentService = {
  getDepartments: async (page = 0, size = 10, search = "", facultyId = null, status = true) => {
    const params = { page, size };
    if (search) params.search = search;
    if (facultyId) params.facultyId = facultyId;
    if (status !== null && status !== undefined) params.status = status;
    const res = await uniAdminApi.get("/university-admin/departments", { params });
    return res.data;
  },

  createDepartment: async (data) => {
    const res = await uniAdminApi.post("/university-admin/departments", data);
    return res.data;
  },

  updateDepartment: async (id, data) => {
    const res = await uniAdminApi.put(`/university-admin/departments/${id}`, data);
    return res.data;
  },

  deleteDepartment: async (id) => {
    const res = await uniAdminApi.delete(`/university-admin/departments/${id}`);
    return res.data;
  },
};

export default departmentService;
